import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { ButtonComponent } from '../../button/button.component';
import { EmptyListInfoComponent } from '../../empty-list-info/empty-list-info.component';
import { ItemSearchComponent } from '../../item-search/item-search.component';
import { ProductCardComponent } from '../../product-card/product-card.component';
import { Resident } from '../../../models/resident.model';
import { Product } from '../../../models/product.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-list-section',
  templateUrl: './list-section.component.html',
  styleUrls: ['../list-of-needs-dialog.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    ItemSearchComponent,
    ProductCardComponent,
    EmptyListInfoComponent,
  ],
})
export class ListSectionComponent {
  @Input() selectedProducts: {
    product: Product | null;
    quantity: number;
    valid: boolean;
  }[] = [];
  @Input() residentControl!: FormControl<Resident>;
  @Input() listTotal!: number;
  @Input() listNumberOfItems!: number;
  @Input() closeDialog: () => void = () => {};
  @Input() addProductsToCart: () => void = () => {};

  @Output() productSelected = new EventEmitter<number>();
  @Output() productRemoved = new EventEmitter<number>();
  @Output() updateQuantity = new EventEmitter<{
    product: Product;
    quantity: number;
  }>();

  constructor(private translateService: TranslateService) {}

  get selectedProductIds(): { id: number; valid: boolean }[] {
    return this.selectedProducts.map(p => ({
      id: p.product ? p.product.id : 0,
      valid: p.valid,
    }));
  }

  get emptyListText() {
    return this.translateService.instant('listOfNeeds.emptyList');
  }
}
